import Highcharts from "highcharts";

export default class BChart
{
	static initialize()
	{
		Highcharts.setOptions({
			lang: {
				decimalPoint: ",",
				months: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec",],
				resetZoom: "Zrušit zoom",
				shortMonths: ["led", "úno", "bře", "dub", "kvě", "čer", "čvc", "srp", "zář", "říj", "lis", "pro",],
				shortWeekdays: ["po", "út", "st", "čt", "pá", "so", "ne",],
				weekdays: {
					1: "pondělí",
					2: "úterý",
					3: "středa",
					4: "čtvrtek",
					5: "pátek",
					6: "sobota",
					0: "neděle",
				}
			},
		});

		document.querySelectorAll(`.chart`).forEach(el => {
			try {
				const options = JSON.parse(el.dataset.chartOptions);
				Highcharts.chart(el, options);
			} catch (error) {
				console.error(error);
			}
		});
	}
}
